<template lang='pug'>
.gift-wrapper
    .pic(v-src="info.photoUrl")
        template(v-if="!info.isAvailable||info.stock==0")
            .available(v-if="!info.isAvailable") 已下架
            .available(v-else) Sold Out
        .tag(v-else-if="info.tag&&info.hasTag") {{info.tag}}
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';

.pic {
    width: 6rem;
    height: 3.6rem;
    background: #fff center/contain no-repeat;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    .tag {
        display: inline-block;
        background: #fff;
        padding: 3px 10px;
        font-size: 12px;
        border: 1px solid #f5f5f5;
    }
    .available {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        color: #fff;
    }
}
</style>